import { useEffect } from "react"
import { useLocation } from 'react-router';


const useBeforeReload = () => {

    const location = useLocation();

    useEffect(() => {

        if (location.pathname.split('/')[2] !== 'purchase' || process.env.NODE_ENV === 'development') return

        const alertUser = (e: BeforeUnloadEvent) => {
            e.preventDefault()
            e.returnValue = ''
        }

        window.addEventListener('beforeunload', alertUser)

        return () => {
            window.removeEventListener('beforeunload', alertUser)
        }

    }, [location.pathname])


}

export default useBeforeReload